export default "__VITE_ASSET__Bkbe_Fgd__"